module.exports = __webpack_public_path__ + "static/img/service-2.22c9264.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/service-2.png
// module id = qotQ
// module chunks = 1